var map = {
	"./I.png": 7913,
	"./a.png": 5215,
	"./achair.png": 2798,
	"./afternoon.png": 5088,
	"./all.png": 9239,
	"./and.png": 3347,
	"./animal.png": 533,
	"./apple.png": 9667,
	"./babies.png": 3556,
	"./baby.png": 4212,
	"./back.png": 84,
	"./bad.png": 3633,
	"./beach.png": 5065,
	"./beer.png": 9483,
	"./begood.png": 1545,
	"./between.png": 4506,
	"./big.png": 7933,
	"./bird.png": 3100,
	"./black.png": 4359,
	"./blue.png": 1094,
	"./book.png": 240,
	"./boy.png": 2503,
	"./boyfriend.png": 1635,
	"./bread.png": 4218,
	"./brother.png": 8321,
	"./but.png": 3723,
	"./by.png": 2074,
	"./cake.png": 7764,
	"./call.png": 7699,
	"./cat.png": 8470,
	"./chair.png": 590,
	"./child.png": 7202,
	"./children.png": 2341,
	"./close.png": 1460,
	"./coffee.png": 6547,
	"./color.png": 1228,
	"./couple.png": 1208,
	"./cupboard.png": 8422,
	"./daughter.png": 2795,
	"./do.png": 4514,
	"./dog.png": 6089,
	"./door.png": 206,
	"./down.png": 7953,
	"./earth.png": 3436,
	"./eight.png": 7695,
	"./english.png": 2643,
	"./evening.png": 4445,
	"./family.png": 8523,
	"./father.png": 7716,
	"./fine.png": 8200,
	"./five.png": 7239,
	"./food.png": 6283,
	"./football.png": 6515,
	"./for.png": 6300,
	"./forest.png": 7433,
	"./forward.png": 229,
	"./four.png": 9478,
	"./friend.png": 132,
	"./from.png": 5914,
	"./full_we.png": 3528,
	"./garden.png": 9732,
	"./girl.png": 846,
	"./girlfriend.png": 7954,
	"./good.png": 9947,
	"./goodbye.png": 6042,
	"./grandma.png": 1139,
	"./grandpa.png": 7098,
	"./green.png": 4306,
	"./grey.png": 978,
	"./guide.png": 2690,
	"./he.png": 7789,
	"./hello.png": 5640,
	"./here.png": 5469,
	"./hi.png": 273,
	"./horse.png": 6123,
	"./hotel.png": 9341,
	"./house.png": 9211,
	"./how.png": 2927,
	"./husband.png": 6871,
	"./iamgood.png": 5014,
	"./icons/badgecitizen.png": 9755,
	"./icons/badgeexpatriate.png": 5117,
	"./icons/badgenomad.png": 7192,
	"./icons/badgetraveler.png": 3538,
	"./icons/vocabularycount.png": 483,
	"./idontwant.png": 7178,
	"./idrink.png": 1455,
	"./ieat.png": 5514,
	"./in.png": 1681,
	"./it.png": 7153,
	"./itissmall.png": 3665,
	"./iwant.png": 8481,
	"./juice.png": 6073,
	"./kids.png": 6531,
	"./lake.png": 5145,
	"./language.png": 9025,
	"./left.png": 332,
	"./lie.png": 6732,
	"./lion.png": 1317,
	"./look.png": 8282,
	"./love.png": 3825,
	"./lunch.png": 3442,
	"./man.png": 4612,
	"./meat.png": 9153,
	"./men.png": 3774,
	"./milk.png": 4436,
	"./morning.png": 7467,
	"./mother.png": 8679,
	"./mountain.png": 4893,
	"./night.png": 1615,
	"./nine.png": 4844,
	"./no.png": 2735,
	"./not.png": 4439,
	"./notebook.png": 3314,
	"./of.png": 5231,
	"./off.png": 3177,
	"./okay.png": 1394,
	"./on.png": 8501,
	"./one.png": 1377,
	"./open.png": 6044,
	"./or.png": 2696,
	"./parent.png": 8140,
	"./pen.png": 7680,
	"./pencil.png": 8885,
	"./pig.png": 9224,
	"./pizza.png": 1401,
	"./plane.png": 2204,
	"./please.png": 2786,
	"./red.png": 9447,
	"./right.png": 1132,
	"./river.png": 3879,
	"./rock.png": 5980,
	"./salad.png": 567,
	"./school.png": 2330,
	"./sea.png": 48,
	"./see.png": 7708,
	"./seven.png": 9333,
	"./shark.png": 2728,
	"./she.png": 5788,
	"./ship.png": 3578,
	"./sister.png": 1369,
	"./sit.png": 8565,
	"./six.png": 7917,
	"./sleep.png": 8186,
	"./small.png": 9098,
	"./son.png": 6217,
	"./sorry.png": 7523,
	"./stand.png": 5678,
	"./stone.png": 5046,
	"./student.png": 2458,
	"./students.png": 9407,
	"./table.png": 5057,
	"./tea.png": 4608,
	"./ten.png": 8105,
	"./thanks.png": 2521,
	"./thankyou.png": 4583,
	"./that.png": 626,
	"./thechair.png": 119,
	"./there.png": 3674,
	"./these.png": 9250,
	"./they.png": 510,
	"./theyarebig.png": 211,
	"./this.png": 2999,
	"./thisisanapple.png": 3831,
	"./thisisnotanapple.png": 5582,
	"./those.png": 3703,
	"./three.png": 5303,
	"./ticket.png": 6093,
	"./to.png": 6169,
	"./toanswer.png": 5917,
	"./toask.png": 5993,
	"./tocome.png": 9482,
	"./todo.png": 2942,
	"./tofind.png": 6211,
	"./togive.png": 4406,
	"./togo.png": 3102,
	"./tohave.png": 8072,
	"./toknow.png": 9618,
	"./tolearn.png": 2169,
	"./tolike.png": 1341,
	"./tomake.png": 7170,
	"./too.png": 4115,
	"./toprovide.png": 441,
	"./toread.png": 9152,
	"./tospeak.png": 5521,
	"./totake.png": 8277,
	"./totravel.png": 7951,
	"./touse.png": 6195,
	"./towalk.png": 2500,
	"./towork.png": 531,
	"./towrite.png": 9763,
	"./train.png": 8595,
	"./tree.png": 5182,
	"./tv.png": 424,
	"./twenty.png": 2961,
	"./two.png": 2760,
	"./under.png": 7545,
	"./up.png": 5024,
	"./walk.png": 8275,
	"./wall.png": 4050,
	"./water.png": 9976,
	"./we.png": 8860,
	"./what.png": 2982,
	"./when.png": 9748,
	"./where.png": 196,
	"./white.png": 1477,
	"./who.png": 1309,
	"./why.png": 8405,
	"./wife.png": 8521,
	"./window.png": 6654,
	"./wine.png": 6683,
	"./with.png": 8669,
	"./woman.png": 7020,
	"./women.png": 7714,
	"./word.png": 9191,
	"./yellow.png": 4774,
	"./yes.png": 9249,
	"./you.png": 5994,
	"./you_plural.png": 8573,
	"./youtoo.png": 4641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;